import { gql } from "@apollo/client";

export const IMPRIMIR_PRESUPUESTO = gql`
mutation imprimirPresupuesto(
    $idEvaluacion: Int!,
    $idDelegacion: Int!, 
    $idTipoPresupuesto: Int!
    ) {
    imprimirPresupuesto(
        input:{
            idEvaluacion: $idEvaluacion
            idDelegacion: $idDelegacion
            idTipoPresupuesto: $idTipoPresupuesto
        }
    ) {
        success,
        error,
        valorEsperado {
            delegacion
            direccionDelegacion
            idEvaluacion
            dia
            mes
            anio
            razonSocial
            atencion
            modulo
            paciente
            numeroAfiliado
            direccionPaciente
            precioDiario
            descripcionPrecioDiario
            fechaDesde
            fechaHasta
            dias
            delegacionTelefono
            ivaPaciente
            total
            descripcionTotal
            idTipoPresupuesto
            periodo
            visitaEnfermeria
            visitaKinesiologia
            visitaPsicologo
            visitaGuardia
            visitaTerapista
            visitaPsiquiatra
            visitaAsistente
        }
    }
}`;